import React__default from 'react';
import { Button } from '../../Components/ui/button.js';
import '../../analytics/events.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'uuid';
import 'lodash/includes';
import '../../types/filters.js';
import { getEntityImage } from '../../utils/assetUtils.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { getRetailerFromId, formatMoney } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import '../../types/Campaign.js';
import '../../types/product.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import '../../api/cache/appConfigQueryOptions.js';
import '@brandclub/types';
import 'lodash/omitBy';
import 'lodash/isNil';
import '../../utils/logger.js';

const ConciergeProductPrice = ({ productsToList, onBuyClick, onOpenRetailerProductPageClick, }) => {
    if (!(productsToList === null || productsToList === void 0 ? void 0 : productsToList.length)) {
        return null;
    }
    return (React__default.createElement("div", { className: "tw:flex tw:flex-col tw:gap-4" },
        React__default.createElement("div", { className: "tw:text-base tw:font-semibold tw:text-foreground tw:mb-2" }, "Ways to buy"),
        React__default.createElement("div", { className: "tw:flex tw:flex-col", style: { gap: '10px' } }, productsToList.map((item, idx) => {
            const retailerName = item.retailerDisplayName || getRetailerFromId(item.retailerId) || '';
            const retailerImage = getEntityImage(item.retailerId, 'retailer');
            const price = formatMoney(item.retailPrice || 0);
            return (React__default.createElement("div", { key: idx, className: "tw:flex tw:w-full" },
                React__default.createElement("div", { className: "tw:flex tw:items-center tw:justify-center tw:shrink-0 tw:overflow-hidden", style: {
                        width: '50px',
                        height: '50px',
                        maxWidth: '50px',
                        maxHeight: '50px',
                        minWidth: '50px',
                        minHeight: '50px',
                        flexShrink: 0,
                        marginRight: '20px',
                        marginTop: '5px',
                        paddingRight: '5px', // Use inline style for single-side padding
                    } },
                    React__default.createElement("img", { alt: "retailer", src: retailerImage, style: {
                            maxWidth: '50px',
                            maxHeight: '50px',
                            width: 'auto',
                            height: 'auto',
                            objectFit: 'contain',
                            display: 'block',
                        } })),
                React__default.createElement("div", { className: "tw:flex tw:flex-1" },
                    React__default.createElement("div", { className: "tw:flex tw:justify-between tw:flex-1 tw:w-full" },
                        React__default.createElement("div", { className: "tw:flex tw:flex-col tw:mb-[5px]" },
                            React__default.createElement("a", { href: item.retailerProductPageUrl, target: "_blank", rel: "noopener noreferrer", onClick: (e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onOpenRetailerProductPageClick(item);
                                }, className: "tw:text-sm tw:font-semibold tw:text-foreground tw:no-underline tw:hover:underline tw:cursor-pointer tw:w-fit" }, retailerName),
                            React__default.createElement("h2", { className: "tw:text-foreground" }, price)),
                        React__default.createElement(Button, { variant: "default", onClick: (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (onBuyClick) {
                                    onBuyClick(item);
                                }
                                else {
                                    onOpenRetailerProductPageClick(item);
                                }
                            }, className: "concierge-view-button tw:min-w-[82px] tw:h-[32px] md:tw:h-[35px] tw:my-[10px] tw:shrink-0 tw:font-semibold" }, "View")))));
        }))));
};

export { ConciergeProductPrice };
//# sourceMappingURL=ConciergeProductPrice.js.map
